/**
 * @Author: DJ
 * @Date:   2021-07-08 15:54:01
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-09-06 10:08:34
 */
import { combineReducers } from 'redux';
import auth from './auth';
import home from './home';
// 市场管理
import operationCommon from './operation/common';
import operationCompany from './operation/company';
import operationService from './operation/service';
import operationCity from './operation/city';
// 审核管理
import auditList from './audit/list';
// 系统管理
import picturenickname from './audit/picturenickname';
import shippingFeeSet from './system/shippingfeeset';
import riderLevelSet from './system/riderlevelset';
import parameter from './system/parameter';
import operatingrule from './system/operatingrule';//系统管理-运营规则
import versions from './system/versions';
import rate from './system/rate';//系统管理-计费比例设置
import feedbacktype from './system/feedbacktype';//系统管理-反馈类型
import financialset from './system/financialset';//系统管理-财务设置
import riskcontrol from './system/riskcontrol';//系统管理-风控管理
import dictionaries from './system/dictionaries';//系统管理-攻略分类字典
import systemOperation from './system/operation';//系统管理-基本信息、财务信息、运营区域、资质信息
import sensitiveword from './system/sensitiveword';//敏感词库
// 订单管理
import distributionorder from './order/distributionorder';
import serviceorder from './order/serviceorder';
import virtualno from './order/virtualno';
import microshippingorder from './order/microshippingorder';
// 账户管理
import insuranceorder from './order/insuranceorder';
import accountflow from './finance/accountflow';
import banktransaction from './finance/banktransaction';
import paymanage from './finance/paymanage';
import taxdeclaration from './finance/taxdeclaration';
import accountstatement from './finance/accountstatement';
import collectionmanage from './finance/collectionmanage';
import platformsubsidy from './finance/platformsubsidy';
import enterpriserecharge from './finance/enterpriserecharge';
import provisionaltaxregister from './finance/provisionaltaxregister';
import enterprisereconciliation from './finance/enterprisereconciliation';
import microbusinessesstatements from './finance/microbusinessesstatements';
// 售后管理
import suggestions from './aftersale/suggestions'; // 意见反馈
import deliveryeval from './aftersale/deliveryeval'; // 评价
import deliveryticket from './aftersale/deliveryticket'; // 罚单
import deliverycomplain from './aftersale/deliverycomplain'; // 投诉
// 客户端管理
import messageMove from './client/messageMove';
import baseset_slide from './client/baseset/slide';
import baseset_mood from './client/baseset/mood';
import help_strategy from './client/help/strategy';
import help_instruction from './client/help/instruction';
// 营销管理
import accumulaterule from './market/accumulaterule';//营销管理-积分规则
import cardcentre from './market/cardcentre';//营销管理-卡券中心
import eventtouch from './market/eventtouch';//营销管理-事件触达
// 合同管理
import contractlist from './contract/contractlist';//合同管理-合同列表
import templatetrac from './contract/templatetrac';//合同管理-合同模板
// 用户管理
import member from './user/member'; // 会员管理
import rider from './user/rider'; // 骑士管理
import black from './user/black'; // 黑名单管理
import agent from './user/agent'; // 经纪人管理
import microbusinesses from './user/microbusinesses'; // 微企管理
// 运营帮助中心
import searchhelp from './companyhelp/searchhelp'; // 搜索中心
// 报表管理
import reporttemplate from './report/reporttemplate'; // 报表模版管理
import reportrecord from './report/reportrecord'; // 报表生成记录
// 权限管理
import structure from './permissions/structure'; // 架构管理
import employee from './permissions/employee'; // 员工管理
import menuconfig from './permissions/menuconfig'; // 菜单管理
import assignauthority from './permissions/assignauthority'; // 权限分配

export default combineReducers({
    auth,
    home,
    // 会员管理
    member,
    rider,
    black,
    agent,
    microbusinesses,
    // 市场管理
    operationCommon,
    operationCompany,
    operationService,
    operationCity,
    // 审核管理
    auditList,
    // 系统管理
    picturenickname,
    shippingFeeSet,
    riderLevelSet,
    operatingrule,
    versions,
    rate,
    feedbacktype,
    financialset,
    riskcontrol,
    dictionaries,
    systemOperation,
    sensitiveword,
    // 参数设置
    parameter,
    // 配送订单
    distributionorder,
    microshippingorder,
    // 增值服务订单
    serviceorder,
    //虚拟号
    virtualno,
    // 账户管理
    microbusinessesstatements,
    insuranceorder,
    accountflow,
    paymanage,
    taxdeclaration,
    accountstatement,
    banktransaction,
    collectionmanage,
    platformsubsidy,
    enterpriserecharge,
    provisionaltaxregister,
    enterprisereconciliation,
    // 售后管理
    suggestions,
    deliveryeval,
    deliveryticket,
    deliverycomplain,
    // 客户端管理
    messageMove,
    baseset_slide,
    baseset_mood,
    help_strategy,
    help_instruction,
    // 营销管理
    accumulaterule,
    cardcentre,
    eventtouch,
    // 合同管理
    contractlist,
    templatetrac,
    // 运营帮助中心
    searchhelp,
    // 报表管理
    reporttemplate,
    reportrecord,
    // 权限管理
    structure,
    employee,
    menuconfig,
    assignauthority,
});